import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { connect } from 'react-redux';
import setFOEAction from '../../redux/actions/createReferenceActions/actionFOE';
import { withTranslation } from 'react-i18next';

class FoeForm extends React.Component {

  constructor(props) {
    super(props);

    if (this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1) {
      localStorage.getItem('language') === 'pt-br' ?
        this.state = {
          foe: { foe: this.props.selectedReferenceData.foe }, foes: [
            { foe: 'Edificações' },
            { foe: 'Edifícios históricos' },
            { foe: 'Estádios' },
            { foe: 'Aeroportos' },
            { foe: 'Pontes e Rodovias' },
            { foe: 'Estacionamentos' },
            { foe: 'Estruturas Hidráulicas' },
            { foe: 'Estações de tratamento de água' },
            { foe: 'Estações de tratamento de efluentes' },
            { foe: 'Tubulações' },
            { foe: 'Túneis' },
            { foe: 'Industrias' },
            { foe: 'Energia' },
            { foe: 'Energia  - Torres Eólicas' },
            { foe: 'Energia  - Barragens' },
            { foe: 'Energia  - Termoelétricas' },
            { foe: 'Energia  - Subestações' },
            { foe: 'Portos' },
            { foe: 'Mineração' },
          ]
        } : localStorage.getItem('language') === 'de' ?
          this.state = {
            foe: { foe: this.props.selectedReferenceData.foe }, foes: [
              { foe: 'Baustofftechnik' },
              { foe: 'Fliesen- und Natursteinverlegung' },
              { foe: 'Nass- und Feuchtraumlösungen' },
              { foe: 'Bodentechnik' },
              { foe: 'Fertigteile' },
              { foe: 'Transportbeton' },
              { foe: 'Hochbau (Neubau und Bauen im Bestand)' },
              { foe: 'Mauerwerk und Historische Gebäude' },
              { foe: 'Stadien' },
              { foe: 'Flughäfen' },
              { foe: 'Brücken und Straße' },
              { foe: 'Parkgaragen' },
              { foe: 'Wasserbauwerke' },
              { foe: 'Trinkwasser' },
              { foe: 'Abwasser' },
              { foe: 'Kanalisation' },
              { foe: 'Tunnelbauwerke' },
              { foe: 'Industriegebäude' },
              { foe: 'Energie' },
              // { foe: 'Baufachhandel' },
              // { foe: 'Baumarkt' },
              { foe: 'Eisenbahn' },
              { foe: 'Botagreen' },
              // { foe: 'InterCompany - ICP' }
            ]
          } :
          this.state = {
            foe: { foe: this.props.selectedReferenceData.foe }, foes: [
              { foe: 'Building Material Technology' },
              { foe: 'Tile and Natural Stone Technology' },
              { foe: 'Wetroom Solutions' },
              { foe: 'Flooring Technology' },
              { foe: 'Buildings (New Construction and Maint.)' },
              { foe: 'Mansory and Historical Buildings' },
              { foe: 'Stadium' },
              { foe: 'Airport' },
              { foe: 'Bridge and Road' },
              { foe: 'Carpark' },
              { foe: 'Hydraulic Construction' },
              { foe: 'Potable Water' },
              { foe: 'Sewage Water' },
              { foe: 'Undeground Sewer' },
              { foe: 'Tunnelling' },
              { foe: 'Industries' },
              { foe: 'Energy and Renewables' },
              // { foe: 'Builders Merchant' },
              // { foe: 'v' },
              { foe: 'Railway' },
              { foe: 'Botagreen' },
              // { foe: 'InterCompany' }
            ]
          }
      this.props.setFOEFunction(this.state.foe.foe)
    } else {
      localStorage.getItem('language') === 'pt-br' ?
        this.state = {
          foe: '', foes: [
            { foe: 'Edificações' },
            { foe: 'Edifícios históricos' },
            { foe: 'Estádios' },
            { foe: 'Aeroportos' },
            { foe: 'Pontes e Rodovias' },
            { foe: 'Estacionamentos' },
            { foe: 'Estruturas Hidráulicas' },
            { foe: 'Estações de tratamento de água' },
            { foe: 'Estações de tratamento de efluentes' },
            { foe: 'Tubulações' },
            { foe: 'Túneis' },
            { foe: 'Industrias' },
            { foe: 'Energia' },
            { foe: 'Energia  - Torres Eólicas' },
            { foe: 'Energia  - Barragens' },
            { foe: 'Energia  - Termoelétricas' },
            { foe: 'Energia  - Subestações' },
            { foe: 'Portos' },
            { foe: 'Mineração' },
          ]
        } : localStorage.getItem('language') === 'de' ?
          this.state = {
            foe: '', foes: [
              { foe: 'Baustofftechnik' },
              { foe: 'Fliesen- und Natursteinverlegung' },
              { foe: 'Nass- und Feuchtraumlösungen' },
              { foe: 'Bodentechnik' },
              { foe: 'Fertigteile' },
              { foe: 'Transportbeton' },
              { foe: 'Hochbau (Neubau und Bauen im Bestand)' },
              { foe: 'Mauerwerk und Historische Gebäude' },
              { foe: 'Stadien' },
              { foe: 'Flughäfen' },
              { foe: 'Brücken und Straße' },
              { foe: 'Parkgaragen' },
              { foe: 'Wasserbauwerke' },
              { foe: 'Trinkwasser' },
              { foe: 'Abwasser' },
              { foe: 'Kanalisation' },
              { foe: 'Tunnelbauwerke' },
              { foe: 'Industriegebäude' },
              { foe: 'Energie' },
              { foe: 'Botagreen' },
              // { foe: 'Baufachhandel' },
              // { foe: 'Baumarkt' },
              { foe: 'Eisenbahn' },
              // { foe: 'InterCompany - ICP' }
            ]
          } : this.state = {
            foe: '', foes: [
              { foe: 'Building Material Technology' },
              { foe: 'Tile and Natural Stone Technology' },
              { foe: 'Wetroom Solutions' },
              { foe: 'Flooring Technology' },
              { foe: 'Buildings (New Construction and Maint.)' },
              { foe: 'Mansory and Historical Buildings' },
              { foe: 'Stadium' },
              { foe: 'Airport' },
              { foe: 'Bridge and Road' },
              { foe: 'Carpark' },
              { foe: 'Hydraulic Construction' },
              { foe: 'Potable Water' },
              { foe: 'Sewage Water' },
              { foe: 'Undeground Sewer' },
              { foe: 'Tunnelling' },
              { foe: 'Industries' },
              { foe: 'Energy and Renewables' },
              // { foe: 'Builders Merchant' },
              // { foe: 'v' },
              { foe: 'Railway' },
              { foe: 'Botagreen' },
              // { foe: 'InterCompany' }
            ]
          }
      this.props.setFOEFunction(this.state.foe.foe)
    }
    this.handleChange = this.handleChange.bind(this);
    this.getSelectedItem = this.getSelectedItem.bind(this);
  }

  handleChange(event, value) {

    if (value !== null) {
      this.setState({ foe: value }, () => {
        this.props.setFOEFunction(this.state.foe.foe);
      });
    } else {
      this.props.setFOEFunction("");
    }
  };

  getSelectedItem() {
    return this.state.foe || [];
  }
  render() {

    const { classes } = this.props;
    const { t } = this.props;

    return (
      <div>
        <Autocomplete
          classes={classes}
          id="combo-box-FOE"
          autoComplete={true}
          onChange={this.handleChange}
          options={this.state.foes}
          isOptionEqualToValue={(option, value) => option.foe === value.foe}
          getOptionLabel={(option) => option.foe}
          value={this.props.selectedReferenceData && window.location.href.indexOf('/editRef') > -1 ? this.getSelectedItem() : this.state.foe[0]} // [0] ?
          noOptionsText={'Wrong input data'}
          sx={{
            "&:hover ": {
              borderColor: "rgb(0,191,255)"
            },
            '& label.Mui-focused': {
              color: 'white'
            },
            "& .Mui-focused ": {
              color: 'white'
            },
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: 'rgb(0,191,255)',
              },
              '&.Mui-focused fieldset': {
                borderColor: 'rgb(47, 79, 79)',
              },
            },
          }}
          renderInput={(params) => <TextField {...params} error={this.props.foeError} style={{ fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)', width: 300, margin: 10 }}
            label={t('create_ref.foe') + "*"} variant="outlined" />}
        />
      </div>
    );

  }
}

function mapStateToProps(state) {
  return {
    foeError: state.createRefState.foeError,
    selectedReferenceData: state.showRefState.selectedReferenceData
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setFOEFunction: foe => {
      dispatch(setFOEAction(foe));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)((withTranslation()(FoeForm)));